module.exports = __webpack_public_path__ + "static/media/poster1.816cf4f4.png";